import { render, staticRenderFns } from "./NominationManagement.vue?vue&type=template&id=1a53c457&"
import script from "./NominationManagement.vue?vue&type=script&lang=js&"
export * from "./NominationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports